import { render, staticRenderFns } from "./WebsiteInformation.vue?vue&type=template&id=20d33320&"
import script from "./WebsiteInformation.vue?vue&type=script&lang=js&"
export * from "./WebsiteInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports